import { useDispatch, useSelector } from "react-redux"
import { productActions } from "../../../../../store/products-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, products } = props
    let selectedpagination = useSelector(state => state.product.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination == index ? 'active' : ''}`} onClick={() => {
        dispatch(productActions.setFilteredItems(products))
        dispatch(productActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;